module.exports = __webpack_public_path__ + "img/4.27e48e24.jpg";